import Page from "../pages/Cookies";
import { pageMeta } from "../lib/meta";
export const meta = () => pageMeta({ title: "Cookie Policy | Gazar", description: "Cookie Policy for gazar.dev operated by QUEEK LIMITED", path: "/cookies" });
export default function Cookies() { return <Page />; }
